import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import "./Wishlist.css";

const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useWishlist();
  const whatsappNumber = "919727983039";

  const handleWhatsAppOrder = (productTitle) => {
    const message = encodeURIComponent(
      `Hello, I would like to order from my Wishlist: ${productTitle}`
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <div className="hm-wishlist-page">
      {wishlist.length === 0 ? (
        <div className="hm-wishlist-container">
          <div className="hm-wishlist-empty-box">
            <div className="hm-wishlist-icon-circle">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
              >
                <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" />
              </svg>
            </div>
            <h2 className="hm-wishlist-title">Your Wishlist is Empty</h2>
            <p className="hm-wishlist-desc">
              Explore our collection and add your favorite B-7000 adhesives and
              repair kits to your wishlist.
            </p>
            <Link to="/shop" className="hm-wishlist-shop-btn">
              Explore Products
            </Link>
          </div>
        </div>
      ) : (
        <div className="hm-wishlist-active-container">
          {/* Header */}
          <div className="hm-wishlist-header">
            <span className="hm-wishlist-tag">SAVED ITEMS</span>
            <h1 className="hm-wishlist-heading">
              My Wishlist ({wishlist.length})
            </h1>
            <p className="hm-wishlist-sub">
              Your favorite items saved in one place for quick ordering.
            </p>
          </div>

          {/* Grid */}
          <div className="hm-wishlist-grid">
            {wishlist.map((item) => (
              <div key={item.id} className="hm-wishlist-card">
                {/* Remove button */}
                <button
                  className="hm-wishlist-remove-btn"
                  onClick={() => removeFromWishlist(item.id)}
                  title="Remove from wishlist"
                  aria-label="Remove item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>

                {/* Product Image */}
                <div className="hm-wishlist-img-box">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="hm-wishlist-img"
                  />
                </div>

                {/* Details */}
                <div className="hm-wishlist-card-body">
                  <h3 className="hm-wishlist-card-title">{item.title}</h3>
                  <p className="hm-wishlist-card-desc">{item.description}</p>

                  <div className="hm-wishlist-price-row">
                    <span className="hm-wishlist-current-price">
                      ₹{item.price}
                    </span>
                    {item.oldPrice && (
                      <span className="hm-wishlist-old-price">
                        ₹{item.oldPrice}
                      </span>
                    )}
                    {item.discount && (
                      <span className="hm-wishlist-discount">
                        {item.discount}
                      </span>
                    )}
                  </div>

                  <button
                    className="hm-wishlist-order-btn"
                    onClick={() => handleWhatsAppOrder(item.title)}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      className="hm-wishlist-wa-icon"
                      fill="currentColor"
                    >
                      <path d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z" />
                    </svg>
                    Order on WhatsApp
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
